import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';
import { SEO } from '@/components/SEO';
import { LegalDocument } from '@/components/LegalDocument';
import { useTranslation } from 'react-i18next';

const Accessibility = () => {
  const { t } = useTranslation('seo');

  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title={t('accessibility.title')}
        description={t('accessibility.description')}
        keywords={t('accessibility.keywords')}
        logicalPath="/accessibilita"
      />
      <Header />
      <section className="py-16 px-6 md:py-24">
        <div className="mx-auto max-w-4xl">
          <LegalDocument namespace="accessibility" />
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default Accessibility;
